import React from 'react'
import HomeBanner from './HomeBanner'
import HomeBrand from './HomeBrand'
import HomeLuxury from './HomeLuxury'
import HomeGrace from './HomeGrace'
import HomeMessage from './HomeMessage'
import HomeCollection from './HomeCollection'
import HomeStyle from './HomeStyle'
import HomeExclusive from './HomeExclusive'
import HomeWedding from './HomeWedding'
import HomeVideoslider from './HomeVideoslider'

export default function Home() {
  return (
    <>
      <HomeBanner />
      <HomeMessage/>
      <HomeBrand/>
      <HomeGrace/>
      <HomeExclusive/>
      <HomeCollection/>
      <HomeVideoslider/>
      <HomeLuxury/>
      <HomeWedding/>
      <HomeStyle/>
    </>
  )
}
